import { inject, Injectable } from '@angular/core';
import { of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { AuthService, IxUser } from 'src/app/core/services/auth.service';
import { ENV } from 'src/app/shared/env/environment.token';
import { Userpilot } from 'userpilot';

@Injectable({
  providedIn: 'root',
})
export class UserpilotService {
  readonly #env = inject(ENV);
  readonly #auth = inject(AuthService);

  initialize(token: string) {
    if (this.#env.USERPILOT_CONFIG.enabled) {
      Userpilot.initialize(token);
    }
  }

  loadConfig() {
    return this.#auth.user$.pipe(
      filter(() => this.#env.USERPILOT_CONFIG.enabled),
      filter(oidcUser => !!oidcUser),
      switchMap((oidcUser: IxUser) => {
        Userpilot.identify(oidcUser.id, {
          applicationDisplayName: 'IX',
          email: oidcUser.email,
          fullName: oidcUser.displayName,
        });
        return of(oidcUser);
      }),
    );
  }

  sendProjectId(projectId?: number) {
    return this.#auth.user$.pipe(
      filter(() => this.#env.USERPILOT_CONFIG.enabled),
      filter(oidcUser => !!oidcUser),
      switchMap((oidcUser: IxUser) => {
        Userpilot.identify(oidcUser.id, { projectId: projectId });

        return of(oidcUser);
      }),
    );
  }

  reload() {
    if (this.#env.USERPILOT_CONFIG.enabled) {
      Userpilot.reload();
    }
  }
}
